"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompositeGraphicsComponent = void 0;
const graphics_sub_components_1 = require("../../rendering/graphics-components/graphics-sub-components");
const e_graphics_component_type_1 = require("../../rendering/graphics-components/e-graphics-component-type");
const link_graphics_components_1 = require("../../rendering/graphics-components/link-graphics-components");
/**
 * @public
 * {@inheritDoc ICompositeGraphicsComponent}
 */
class CompositeGraphicsComponent {
    constructor(graphicsComp, groupUpdatesByEntity) {
        this.type = e_graphics_component_type_1.EGraphicsComponentType.Composite;
        this.subComponents = new graphics_sub_components_1.GraphicsSubComponents([graphicsComp]);
        this.groupUpdatesByEntity = groupUpdatesByEntity;
    }
    static createOne(graphicsComp) {
        return new CompositeGraphicsComponent(graphicsComp, false);
    }
    static createOneLinked(graphicsComp) {
        return new CompositeGraphicsComponent(graphicsComp, true);
    }
    addComponent(graphicsComp) {
        this.subComponents.addComponent(graphicsComp);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return this;
    }
    build() {
        if (this.groupUpdatesByEntity) {
            (0, link_graphics_components_1.linkGraphicsComponents)(this.subComponents.getSubComponents());
        }
        return this;
    }
    recurseIterate(filterOrCallback, callback) {
        if (callback == null) {
            this.recurseIterateImpl(filterOrCallback, undefined, this);
        }
        else {
            this.recurseIterateImpl(callback, filterOrCallback, this);
        }
    }
    recurseIterateImpl(callback, filter, composite) {
        const comps = composite.subComponents.getSubComponents();
        for (let i = 0, iEnd = comps.length; i < iEnd; ++i) {
            const comp = comps[i];
            if (filter == null || filter === comp.type) {
                callback(comp, composite, i);
            }
            if (comp.type === e_graphics_component_type_1.EGraphicsComponentType.Composite) {
                this.recurseIterateImpl(callback, filter, comp);
            }
        }
    }
}
exports.CompositeGraphicsComponent = CompositeGraphicsComponent;
//# sourceMappingURL=composite-graphics-component.js.map